import {Service, Module} from 'app/decorators.js';
import R from 'app/resource';
import BaseStore from './base';


@Module({
    name: 'app.store.chemical.program',
    modules: [
        R,
    ],
})
@Service('ChemicalProgramStore')
export default class Store extends BaseStore {
    constructor ($q, R) {
        "ngInject";
        super($q, R);
        this.endpoint = this.R.all('chemical-programs');
    }
}



// WEBPACK FOOTER //
// ./src/app/stores/chemical.program.js